import React from 'react';
import { CellText, GenericCell } from '../../templates/tables/Cells';
import * as con from '../../GlobalConstants';

function SecondLeftRow({ data, styles, isSmallScreen }) {
    return (
        <>
        <div className="flex-fila" style={{ padding: `1px 10px`, textAlign: 'center', fontSize: styles.fontSize }}>
            {!isSmallScreen && (
                <div className="flex-celda" style={{ padding: styles.padding }}>
                    <GenericCell cellType={con.MONEY} allowDecimals ={true} value={data.cierreAnterior} editing={false} />
                </div>
            )}
            <div className="flex-celda" style={{ padding: styles.padding }}>
                <GenericCell cellType={con.MONEY} currency = {con.MONEY_COP} allowDecimals ={true} value={data.diffCierreAnterior} editing={false} />
            </div>
            <div className="flex-celda" style={{ padding: styles.padding }}>
                <GenericCell cellType={con.MONEY} currency = {con.MONEY_COP} allowDecimals ={true} value={data.variacionSemanal} editing={false} />
            </div>
            <div className="flex-celda" style={{ padding: styles.padding }}>
                <CellText value={data.indicadorAgotamiento} editing={false} />
            </div>
        </div>
        <div className="flex-fila uneven-row" style={{ padding: `1px 10px`, textAlign: 'center', fontSize: styles.fontSize }}>
            <div className="flex-celda" style={{ padding: styles.padding }}>
                <CellText value={" "} editing={false} />
            </div>
            <div className="flex-celda" style={{ padding: styles.padding }}>
                <GenericCell cellType={con.PERCENTAGE} decimalScale = {2} value={data.diffCierreAnteriorPorcentaje} editing={false} />
            </div>
            <div className="flex-celda" style={{ padding: styles.padding }}>
                <GenericCell cellType={con.PERCENTAGE} decimalScale = {2} value={data.variacionSemanalPorcentaje} editing={false} />
            </div>
            <div className="flex-celda" style={{ padding: styles.padding }}>
                <CellText value={" "} editing={false} />
            </div>
        </div>
        </>
    );
}

export default SecondLeftRow;
